export const MENU_ITEMS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "appointments", label: "Appointments" },
  { key: "clients", label: "Clients" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "staff", label: "Team Members" },
  { key: "services", label: "Services" },
  { key: "branches", label: "Branch Master" },
  { key: "inventory", label: "Inventory" },
  { key: "purchase", label: "Purchase" },
  { key: "sales", label: "Sales" },
  { key: "reports", label: "Reports" },
  { key: "settings", label: "Settings" },
  { key: "users", label: "Users" }
];

export const TEAM_MEMBER_DEFAULT_MENUS = ["appointments", "sales"];

export const ALL_MENU_KEYS = MENU_ITEMS.map(item => item.key);

export const MENU_AVAILABLE_ACTIONS = {
  dashboard: [],
  appointments: ["add", "edit", "delete"],
  clients: ["add", "edit", "delete"],
  whatsapp: ["add"],
  staff: ["add", "edit", "delete"],
  services: ["add", "edit", "delete"],
  branches: ["add", "edit", "delete"],
  inventory: ["add", "edit", "delete"],
  purchase: ["add", "edit", "delete", "print"],
  sales: ["add", "edit", "delete", "print"],
  reports: ["print"],
  settings: ["edit"],
  users: ["add", "edit", "delete"]
};
